import { render, staticRenderFns } from "./ModalESImagem.vue?vue&type=template&id=68459a94&scoped=true&"
import script from "./ModalESImagem.vue?vue&type=script&lang=js&"
export * from "./ModalESImagem.vue?vue&type=script&lang=js&"
import style0 from "./ModalESImagem.vue?vue&type=style&index=0&id=68459a94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68459a94",
  null
  
)

export default component.exports